module.exports = [
	{
		"match": "ecommerce",
		"title": "eCommerce Plugins",
		"content": "Add more features to your WordPress store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce\">eCommerce plugins for WordPress</a>. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress/ecommerce"
	},
	{
		"match": "ecommerce/prestashop",
		"title": "PrestaShop Modules",
		"content": "Add more features to your PrestaShop store with premium <a href=\"https://codecanyon.net/category/plugins/prestashop\">PrestaShop modules</a> and Addons. ",
		"button_label": "Browse Modules",
		"link": "https://codecanyon.net/category/plugins/prestashop"
	},
	{
		"match": "ecommerce/opencart",
		"title": "OpenCart Extensions",
		"content": "Add more features to your OpenCart store with premium <a href=\"https://codecanyon.net/category/plugins/opencart\">OpenCart extensions</a>. ",
		"button_label": "Browse Extensions",
		"link": "https://codecanyon.net/category/plugins/opencart"
	},
	{
		"match": "ecommerce/magento",
		"title": "Magento Plugins",
		"content": "Once you've found the perfect Magento theme for your store, be sure to enhance it with <a href=\"https://codecanyon.net/category/plugins/magento-extensions\">premium Magento plugins on CodeCanyon</a>. ",
		"button_label": "Browse Magento Plugins",
		"icon_source": "magneto.png",
		"link": "https://codecanyon.net/category/plugins/magento-extensions"
	},
	{
		"match": "marketing",
		"title": "Web Elements",
		"content": "Need some marketing-related graphics to go along with your marketing template? If so, check out the <a href=\"https://graphicriver.net/category/web-elements\">web elements</a> on GraphicRiver.",
		"button_label": "Browse Web Elements",
		"icon_source": "learn_v1.png",
		"link": "https://graphicriver.net/category/web-elements"
	},
	{
		"match": "psd-templates",
		"title": "Full HTML Templates",
		"content": "If you'are looking for a fully functional web template, rather than just a PSD, check out the <a href=\"https://themeforest.net/category/site-templates\">Site Templates</a> category on ThemeForest. ",
		"button_label": "Browse Site Templates",
		"icon_source": "learn_v1.png",
		"link": "https://themeforest.net/category/site-templates"
	},
	{
		"match": "wordpress",
		"title": "Learn how to use WordPress",
		"content": "Check out our <a href=\"https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse\">beginner's guide to WordPress</a> on Tuts+. You will learn how to to install WordPress, customise your theme and much more.",
		"button_label": "Start Free Course",
		"icon_source": "envato-tuts-black.png",
		"link": "https://webdesign.tutsplus.com/courses/a-beginners-guide-to-using-wordpress?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_FreeWPCourse"
	},
	{
		"match": "wordpress",
		"title": "Get your theme installed",
		"content": "Hire an expert to install your WordPress theme for you, starting from $50 on Envato Studio.",
		"button_label": "Install Theme Now",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/themeforest-installation?utm_source=EnvatoMarket&utm_medium=TF_Sidebar&utm_campaign=Envato_TF_Sidebar_WPInstall"
	},
	{
		"match": "wordpress/ecommerce",
		"title": "WordPress Plugins",
		"content": "Add powerful features to your online shop with thousands of unique <a href=\"https://codecanyon.net/category/wordpress\">WordPress plugins</a> on CodeCanyon. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress"
	},
	{
		"match": "wordpress/ecommerce/woocommerce",
		"title": "WooCommerce Plugins",
		"content": "Add more features to your WooCommerce store with premium <a href=\"https://codecanyon.net/category/wordpress/ecommerce/woocommerce\">WooCommerce plugins</a>. ",
		"button_label": "Browse Plugins",
		"link": "https://codecanyon.net/category/wordpress/ecommerce/woocommerce"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/themeforest.json
// module id = 469
// module chunks = 1